import { useEffect, useState } from "react";

import { useWindowEvent } from "./useWindowEvent";

// @todo: make this function signature nicer
export const useLocalStorage = <T = any>(key: string, initialValue: any | null = null, json = false) => {
  const [currentValue, setCurrentValue] = useState<T>(() => {
    const item = localStorage.getItem(key);
    if (item) {
      return json ? JSON.parse(item) : item;
    } else {
      return initialValue;
    }
  });

  const handler = (e: StorageEvent) => {
    if (e.storageArea === localStorage && e.key === key) {
      const newValue = json && typeof e.newValue === "string" ? JSON.parse(e.newValue) : e.newValue;
      if (newValue !== currentValue) {
        setCurrentValue(newValue);
      }
    }
  };

  useWindowEvent("storage", handler);

  useEffect(() => {
    const item = json ? JSON.stringify(currentValue) : (currentValue as string);
    localStorage.setItem(key, item);
  }, [key, currentValue, json]);

  return [currentValue, setCurrentValue] as const;
};
